import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { StopPropagationModule } from '@y42/core/stop-propagation';
import { JobStatusHeaderRendererComponent } from './job-status-header-renderer.component';

@NgModule({
  imports: [CommonModule, FontAwesomeModule, StopPropagationModule],
  declarations: [JobStatusHeaderRendererComponent],
  exports: [JobStatusHeaderRendererComponent],
})
export class JobStatusHeaderRendererModule {}
